import { configureStore } from "@reduxjs/toolkit";
import adminAuthReducer from "./slices/adminAuthSlice";
import adminAccountsReducer from "./slices/adminAccountsSlice";
import activityLogsReducer from "./slices/activityLogsSlice";
import appMessageReducer from "./slices/appMessageSlice";

export const store = configureStore({
  reducer: {
    adminAuth: adminAuthReducer,
    adminAccounts: adminAccountsReducer,
    activityLogs: activityLogsReducer,
    appMessage: appMessageReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
